export default __webpack_public_path__ + "static/media/cancel-procedure.ffea89c2.svg";